import { Page } from "../components/_partials";
import Header from "../components/Header";
import Main from "../components/Main";

function Home() {
  return (
    <Page>
      <Header />
      <Main />
    </Page>
  );
}

export default Home;
